import React from 'react';
import PropTypes from 'prop-types';
import styles from '../components/AboutBio.module.scss';
import BioThumbnail from '../components/BioThumbnail';
import { Typography } from '@mui/material';


const BioList = (props) => {

  const thumbnailClick = (bio) => { 
    props.ThumbnailClick(bio);
  };

  if (!props.Bios || props.Bios.length === 0) {
    return <div>No biographies available.</div>;
  }

  return (
    <div className={styles.transparent}>
      <Typography variant="h5" className={styles.whiteText} gutterBottom>
        Meet the Team:
      </Typography>
      {props.Bios.map((bio, index) => (
        <div key={index} className={styles.bioCard}>
          <div className={styles.photoSection}>
            <BioThumbnail Bio={bio} ThumbnailClick={thumbnailClick} />
          </div>
        </div>
      ))}   
    </div>
  );
};

BioList.propTypes = {
  Bios: PropTypes.array.isRequired,
  ThumbnailClick: PropTypes.func,
};

BioList.defaultProps = {
  ThumbnailClick: () => {},
};

export default BioList;
